import { MathHelper } from "../../../dev/utils/MathHelper";
import { ArrayHelper } from '../../../dev/utils/ArrayHelper';

export class SoundConfig {


    static readonly AS_WIN: string = "asWin";
    static readonly AS_WIN_BIG: string = "asWinBig";
    // CARS

    static readonly CAR_LAND_YELLOW: string = "wc3Land";
    static readonly CAR_LAND_GREEN_AND_RED: string = "wc12Land";
    static readonly CAR_RG_CRASH: string = "wcCrash";
    static readonly CAR_TAKE_OFF: string[] = ["wcTakeOff","wcTakeOff2","wcTakeOff3"];
    static readonly CAR_TRANSFORM_TO_WILD: string = "wcWildTransform";

    static readonly CAR_MOVES_SETUP: string = "carMoveOnReels";
    static readonly CAR_STICKY: string = "stickyWild";

    
    /*/*/
    

    static readonly SETUP_CAR_PLUS_CAR:string = "fsSetupCar";
    static readonly SETUP_CAR_PLUS_TIRE:string = "fsSetupTire";


    static readonly PLUS_ONE_FREESPIN:string = "plus1";

    static readonly SETUP_CAR_PLUS_FS:string = "fsSetupPlusOneOnReel";
    static readonly SETUP_CAR_PLUS_INVENTORY:string = "fsSetupPlusOneInventory";
    
    static readonly SETUP_CAR_BIRD_HIT:string = "freespinPlusSeagull";
    

    static readonly SETUP_CAR_SWITCH_LANE: string = "carChangeLane";
    static readonly SETUP_CAR_ENTER: string = "carEnterFS";
    static readonly SETUP_CAR_LEAVES: string = "carExitFS";

    // INTRO-POSTER
    
    static readonly SPLASH_INTRO: string[] = ["preMorningRushSetUp","preHighwayJamSetUp","preCityMayhemSetUp"];
    static readonly SPLASH_INTRO_BTN: string[] = ["continueButtonMorningRush","continueButtonHighwayJam","continueButtonCityMayhem"];
    static readonly SPLASH_INTRO_CONGRATS: string = "fsSetupCongratulations";

    
    static readonly GAME_INTRO:string = "gameIntro";
    static readonly GAME_INTRO_LOGO:string = "gameIntroSignLands";


    // MULTIPLIER SOUNDS

    static readonly MULT_LAND =  "multiplierLand";
    static readonly MULT_LAND_UPGRADE =  "multiplierUpgrade";

    // DURING FS

    static readonly PLUS_ONE_FS:string = "fsPlusSpin";
    static readonly PLUS_ONE_COUNTER_FS:string = "freeSpinCounter";

    // TRANSITIONS
    static readonly MAP_TRANSITIONS:string = "transitionToAndFromFS";

    // BACKGROUND MUSIC - LOOPS

    static readonly MAIN_AMBIANCE: string = "background-music-main-ambience";
    static readonly MAIN_MUSIC: string = "background-music-main";
    static readonly FS_AMBIANCE: string = "background-music-fs1";

    static readonly FS_MUSIC_SETUP_LOOP: string[] = ["morningRushIntroLoop","highwayJamIntroLoop","cityMayhemIntroLoop"];
    static readonly FS_MUSIC_INTRO: string[] = ["fsMorningRushLoop","fsHighwayJamLoop","fsCityMayhemLoop"];

    // static readonly SETUP_LOOP:string = "freespinSetupLoop";
    
    static readonly FS_SUPER_AMBIANCE_START: string = "bgFsSuperStart";
    static readonly FS_SUPER_AMBIANCE_LOOP: string = "bgFsSuper";
    static readonly FS_SUPER_AMBIANCE_STOP: string = "bgFsSuperEnds";

    // NORMAL WIN-SOUNDS

    static readonly COUNTUP: string = "countup";
    static readonly COUNTUP_ENDS: string[] = ["countupEndsTiny", "countupEndsSmall", "countupEndsMedium", "countupEndsLarge"];

    static readonly WIN_HIGHLIGHT: string = "winHighlight";

    static readonly WIN_SOUNDS: string[] = ["winTiny", "winSmall", "winMedium", "winLarge"];
    static readonly BET_LINE_LENGTH: string[] = ["betlineHighlight1", "betlineHighlight2", "betlineHighlight3"];
    static readonly BET_LINE_BIG_WIN: string = "betlineHighlightBigwin";

    // BIG WIN-SOUNDS

    
    static readonly BIG_WIN_PRE_START: string = "preBigWin";
    static readonly BIG_WIN_LVL_CHANGE: string = "bigwinLevelChange";
    static readonly BIG_WIN_ENDING: string = "bigwinEnding";


    public static bigWinLoop(lvl:number):string{ return "bigwinLevel" + MathHelper.clamp(lvl,1,5)}
    public static bigWinEnd(lvl:number):string{ return "bigwinEndsLevel" + MathHelper.clamp(lvl,1,5)}

    // REEL SOUNDS

    static readonly REELS_SPINNING: string = "reelsSpinning";
    static readonly REELS_LANDING: string = "reelLanding1";
    static readonly REELS_DEFAULT_BOUNCE: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];


    // RESPIN 
    
    static readonly RESPIN_POSTING:string = "respinPosting";
    static readonly RESPIN_ANTICIPATION:string = "respinAnticipation";
    static readonly RESPIN_ANTICIPATION_2:string = "respinAnticipation2";
    static readonly RESPIN_ANTICIPATION_END:string = "respinAnticipationEnd";
    static readonly RESPIN_ANTICIPATION_END_2:string = "respinAnticipation2End";
    


    // SetupSummary


    static readonly SUMMARY_SETUP_SPLASH:string = "fsSetupSummarySplash";
    static readonly SUMMARY_SETUP_FS_WON:string = "fsSetupFreespinsWon";
    static readonly SUMMARY_SETUP_CAR_WON:string = "fsSetupCarsUpgradedText";
    

    // OUT

    static readonly SCATTER_FS_LANDING: string = "scatterFS";
    static readonly SCATTER_LANDINGS: string[] = ["scatterLevel1", "scatterLevel2", "scatterLevel3", "scatterLevel4", "scatterLevel5"];

    static readonly NO_WIN_POSTERS: string[] = ["noWinBollocks", "noWinBurp", "noWinWasted"]
    
    static readonly SCATTER_ANTICIPATION_NORMAL: string = "anticipation1";
    static readonly SCATTER_ANTICIPATION_FS: string = "anticipation2";

    static readonly SCATTER_ANTICIPATION_LANDING: string = "anticipationReelLanding";

    static readonly MYSTERY_LAND: string =  "mysterySymbolLand";
    static readonly MYSTERY_REVEAL: string =  "mysterySymbolReveal";

    static readonly BONUS_INTRO: string = "fsNormalIntroStart";
    static readonly BONUS_INTRO_SFS: string = "fsNormalIntroStart";
    static readonly BONUS_INTRO_SSFS: string = "fsNormalIntroStart";

    static readonly IDLE_HAWKING: string = "doorHawKing";
    static readonly HAWKING_TRANSFORM: string = "hawKingTransform";
    
    static readonly XSPLIT_CUT: string = "xSplitCut";

    static readonly CONTINUE_SETUP_SUM: string = "continueButton";
    static readonly CONTINUE_AFTER_FS: string = "continueButtonPostFS";
    static readonly CONTINUE_AFTER_FS_BUY: string = "continueButtonPostFSBonusBuy";

    // continueButtonPostFS

    static readonly CAP_WIN_COUNTER:string = "capWinCountup";
    static readonly CAP_WIN_MUSIC:string = "capWinMusic";
    static readonly CAP_WIN_BTN:string = "capWinContinueButton";

    public static swearSound(anim:string):string{
        switch(anim){
            case "Speech_Bitch":
                return ArrayHelper.getRandomValue(["bubbleBringIt","bubbleScreamFemale"])
            case "Speech_Shit":
                return ArrayHelper.getRandomValue(["bubbleShit","bubbleMumble"])
            default:
                return ArrayHelper.getRandomValue(["bubbleFuck","bubbleMotherFucker","bubbleSatan"])
        }
    }
}